<ion-header class="ion-no-border">
    <ion-toolbar mode="ios">
        <ion-buttons slot="start" *ngIf="showBackButton">
            <ion-button (click)="back()">
                <ion-icon class="header-back__icon--desktop ion-hide-md-down"
                          mode="ios"
                          name="chevron-back"></ion-icon>
                <ion-icon class="header-back__icon--mobile ion-hide-lg-up"
                          mode="ios"
                          name="arrow-back"></ion-icon>
                <ion-text class="ion-hide-md-down"
                          *ngIf="!isFlyerPage">Back</ion-text>
                <ion-text class="ion-hide-md-down"
                          *ngIf="isFlyerPage">Available Properties</ion-text>
            </ion-button>
        </ion-buttons>

        <ion-title>
            <ion-img class="header__logo"
                     [routerLink]="['/']"
                     src="{{ settings.logo }}"
                     alt="Organization Logo"></ion-img>
        </ion-title>

        <ion-buttons slot="end">
            <!-- neither user or customer is logged in -->
            <ion-img class="header__avatar header__avatar--small"
                     *ngIf="!auth.isUserLoggedIn && !auth.isCustomerLoggedIn && !isMobilePlatform"
                     (click)="openLoginModal()"
                     src="../../assets/icon/Avatar_300x300.png"
                     alt="Login Graphic"></ion-img>

            <div class="header__avatar"
                 *ngIf="!auth.isUserLoggedIn && auth.isCustomerLoggedIn">
                <app-vesta-avatar size="small"
                                  (click)="navigate('customer')"
                                  [customerEmail]="auth.customerEmail"></app-vesta-avatar>
            </div>

            <div class="header__avatar"
                 *ngIf="!auth.isCustomerLoggedIn && auth.isUserLoggedIn">
                <app-vesta-avatar size="small"
                                  (click)="navigate('user')"
                                  [user]="auth.currentUser"></app-vesta-avatar>
            </div>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-progress-bar type="indeterminate" *ngIf="showProgressBar"></ion-progress-bar>
<!--    <div class="dashboard-inner-content">-->
        <ng-content></ng-content>
<!--    </div>-->

    <ion-footer class="ion-no-border ion-padding">
        <div class="footer__trademark">Powered by Vesta, © {{ year }}</div>
<!--        <a [routerLink]="['/']">Disclaimer</a> - -->
<!--        <a [routerLink]="['/']">Terms of Service</a> - -->
        <a [routerLink]="['/privacy']">Privacy Policy</a>
    </ion-footer>
</ion-content>
